import { DownloadOutlined, LoadingOutlined } from '@ant-design/icons';
import React from 'react';
import ReportButton from '~/components/atoms/ReportButton';

import Header from '../Header/Header';

export interface IProps {
  title: string;
  subtitle: string;
  hasModal?: boolean;
  hasExport?: boolean;
  openModal?: () => void;
  isDisabledButton?: boolean;
  exportState?: IReportExportState;
  additionalAction?: React.ReactNode;
}

export type IReportExportState = {
  isOpen: boolean;
  isLoading: boolean;
  isError: boolean;
  isSuccessful: boolean;
  errorMessage: string;
  isDisabled: boolean;
};

const emptyExportState: IReportExportState = {
  errorMessage: '',
  isDisabled: false,
  isError: false,
  isLoading: false,
  isOpen: false,
  isSuccessful: false,
};

export default function ReportHeader({
  title,
  subtitle,
  hasExport = false,
  openModal = () => { },
  isDisabledButton = false,
  exportState = emptyExportState,
  additionalAction = null,
}: IProps) {
  const handleModalOpen = () => {
    openModal();
  };

  const exportComponent = (
    <ReportButton
      onClick={handleModalOpen}
      disabled={exportState.isDisabled || exportState.isLoading || isDisabledButton}
      aria-label="Exportar relatório"
    >
      Exportar relatório
      {exportState.isLoading ? (
        <LoadingOutlined aria-label="Carregando dados para exportação" />
      ) : (
        <DownloadOutlined aria-label="Exportar dados" />
      )}
    </ReportButton>
  );

  const additionalActions = [];
  if (additionalAction) {
    additionalActions.push(additionalAction);
  }
  if (hasExport) {
    additionalActions.push(exportComponent);
  }

  return <Header title={title} subtitle={subtitle} additionalActions={additionalActions} />;
}
